import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Race} from '../shared/classes/Race';
import {RacesService} from '../shared/services/databaseServices/races/races.service';
import {EditService} from '../shared/services/editService/edit.service';
import {FormBuilder, Validators} from '@angular/forms';
import {FioService} from '../shared/services/databaseServices/fioService/fio.service';
import {FioConfig} from '../shared/classes/FioConfig';

@Component({
  selector: 'app-fio-detail',
  templateUrl: './fio-detail.component.html',
  styleUrls: ['./fio-detail.component.css']
})
export class FioDetailComponent implements OnInit {

  private static NEW_ID = 'new';

  plusButton = false;
  editButton = true;

  isNew = false;
  id = undefined;
  races: Race[] = [];
  fioConfig: FioConfig = undefined;

  createTooltip = 'fioSetting.tooltip.saveToolTip';
  deleteTooltip = 'fioSetting.tooltip.deleteToolTip';
  addTooltip = 'fioSetting.tooltip.addToolTip';

  fioForm = this.formBuilder.group({
    profile: ['', [Validators.required]],
    token: ['', [Validators.required]]
  });

  constructor(private activatedRoute: ActivatedRoute,
              private router: Router,
              private editService: EditService,
              private formBuilder: FormBuilder,
              private fioService: FioService,
              private racesService: RacesService) { }

  ngOnInit() {
    this.id = this.activatedRoute.snapshot.paramMap.get('id');
    this.isNew = this.id === FioDetailComponent.NEW_ID;
    if(this.isNew) {
      this.fioConfig = new FioConfig();
    } else {
      this.loadFioConfig();
      this.plusButton = false;
      this.editButton = true;
      this.fioForm.get('profile').disable();
    }
  }

  private loadFioConfig() {
    this.fioService.getOne(this.id).then( data => {
      this.fioConfig = new FioConfig();
      this.fioConfig.id = data.id;
      this.fioConfig.token = data.data().token;
      this.fioConfig.profile = data.data().profile;
      this.pathForm(this.fioConfig);
    });
  }

  private pathForm(fioConfig: FioConfig) {
    this.fioForm.patchValue({
      profile: fioConfig.profile,
      token: fioConfig.token
    });
  }

  private loadRaces() {
    this.racesService.getRaces().then( data => {
      data.forEach( item => {
        const race: Race = new Race();
        race.id = item.id;
        race.name = item.data().name;
        // race.organizer = item.data().poradatel;
        race.dateStart = item.data().dateStart;

        this.races.push(race);
      });
    });
  }

  save(item){
    const config: FioConfig = new FioConfig();
    config.token = this.fioForm.get('token').value;
    config.profile = this.fioForm.get('profile').value;
    config.id = this.fioForm.get('profile').value;
    if (this.isNew) {
      this.id = config.id;
    }
    this.fioService.save(this.id, config).then( () => {
      this.router.navigate(['/admin/settings/fio']);
    }).catch( err => {
      console.dir(err);
    });
  }

  remove(item){
    this.fioService.remove(this.id).then(() => {
      this.router.navigate(['/admin/settings/fio']);
    }).catch( err => {
      console.dir(err);
    })
  }

  add(item){

  }

}
